var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 20",
    style: {
      enableBackground: "new 0 0 21 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,19.9H5.6c-2.8,0-5-2.2-5-5V5.1c0-2.8,2.2-5,5-5h9.8c2.8,0,5,2.2,5,5v9.7C20.4,17.6,18.2,19.9,15.4,19.9 z M5.6,2.1c-1.7,0-3,1.3-3,3v9.7c0,1.7,1.3,3,3,3h9.8c1.7,0,3-1.3,3-3V5.1c0-1.7-1.3-3-3-3H5.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,13.8c-0.5,0-1-0.2-1.4-0.6l-2-2c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l2,2l4.4-4.3 c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4l-4.4,4.3C10.7,13.6,10.2,13.8,9.7,13.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmark);
export default __webpack_public_path__ + "static/media/icon-checkmark.40ac45d8fd7be5de9e901877c8ed6076.svg";
export { ForwardRef as ReactComponent };